module.exports = __webpack_public_path__ + "static/media/tutorial_money_two@2x.d9085d7d.png";